import { IconProps } from '@chakra-ui/react'
import React from 'react'

import * as AllIconsBrand from './all'

export type IconNames = keyof typeof AllIconsBrand
export interface IconByNameProps extends IconProps {
  inverted?: boolean
  name: string
}

export const IconByName: React.FC<IconByNameProps> = ({
  color,
  fill,
  inverted,
  name,
  ...props
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Icon = (AllIconsBrand as Record<string, any>)[name]

  return Icon ? (
    <Icon
      background={inverted ? fill || color : undefined}
      borderRadius="50%"
      color={inverted ? 'white.0' : fill || color}
      {...props}
    />
  ) : null
}

export type IconNamesBrand = keyof typeof AllIconsBrand
